/**
 * Throttles a function so it only runs once every `interval` milliseconds.
 *
 * Each call to `throttle(fn, interval)` returns a new throttled version of `fn`
 * with its own internal timing state.
 *
 * @param {Function} action - The function to throttle.
 * @param {number} interval - Minimum time (in ms) between allowed calls.
 * @returns {Function} - A throttled version of the original function.
 */
const throttled = (action, interval) => {
    let lastCall = 0;
    return (...args) => {
        const now = Date.now();
        if (now - lastCall >= interval) {
            lastCall = now;
            action.apply(this, args);
        }
    };
}

export { throttled };